module.exports = __webpack_public_path__ + "static/media/lc.c3c95ffe.svg";